const phoneNumberFormatter = (value) => (value ? value.toString().replace(/\D/g, '').slice(1) : '');

export default phoneNumberFormatter;
